import api from './api';
import { Appointment, AppointmentRequest, AvailabilitySlot, BundleAppointmentRequest } from '../types/appointment.types';

export const appointmentService = {
    // Get all appointments for current user
    getMyAppointments: async (): Promise<Appointment[]> => {
        const response = await api.get<Appointment[]>('/appointments/my-history');
        return response.data;
    },

    // Create new appointment
    createAppointment: async (request: AppointmentRequest): Promise<Appointment> => {
        const response = await api.post<Appointment>('/appointments', request);
        return response.data;
    },

    // Get available time slots for a barber on a specific date
    getAvailableSlots: async (barberId: number, date: string, consecutiveSlots: number = 1): Promise<AvailabilitySlot[]> => {
        const response = await api.get<AvailabilitySlot[]>(`/appointments/availability`, {
            params: { barberId, date, consecutiveSlots }
        });
        return response.data;
    },

    createBundleAppointment: async (request: BundleAppointmentRequest): Promise<Appointment[]> => {
        const response = await api.post<Appointment[]>('/appointments/bundle', request);
        return response.data;
    },

    // Cancel an appointment (requires reason)
    cancelAppointment: async (appointmentId: number, reason: string): Promise<Appointment> => {
        const response = await api.post<Appointment>(`/appointments/${appointmentId}/cancel`, { reason });
        return response.data;
    },

    // Reschedule an appointment (requires new date, time and reason)
    rescheduleAppointment: async (
        appointmentId: number,
        newDate: string,
        newTime: string,
        reason: string
    ): Promise<Appointment> => {
        const response = await api.post<Appointment>(`/appointments/${appointmentId}/reschedule`, {
            newDate,
            newTime,
            reason
        });
        return response.data;
    },

    // Get available barbers for delegating an appointment
    getAvailableBarbersForDelegation: async (appointmentId: number): Promise<{id: number, name: string, nickname: string}[]> => {
        const response = await api.get<{id: number, name: string, nickname: string}[]>(`/appointments/${appointmentId}/available-barbers`);
        return response.data;
    },

    // Delegate appointment to another barber
    delegateAppointment: async (appointmentId: number, targetBarberId: number): Promise<Appointment> => {
        const response = await api.put<Appointment>(`/appointments/${appointmentId}/delegate`, { targetBarberId });
        return response.data;
    }
};
